import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AdminGuard, AuthGuard, IsActiveGuard } from './guards';
import { IconsComponent } from '@shared/components/icons/icons.component';

export const Routing: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./website/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: 'icons',
    component: IconsComponent,
  },
  {
    path: 'auth',
    canActivate: [IsActiveGuard],
    loadChildren: () =>
      import('./website/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./website/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'deals',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./website/deals/deals.module').then((m) => m.DealsModule),
  },
  {
    path: 'lenderslists',
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () =>
      import('./website/banklists/bank-lists.module').then(
        (m) => m.BankListsModule,
      ),
  },
  {
    path: 'lenders',
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () =>
      import('./website/banks/banks.module').then((m) => m.BanksModule),
  },
  {
    path: 'companies',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./website/companies/companies.module').then(
        (m) => m.CompaniesModule,
      ),
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./website/users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'services',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./website/customized-services/customized-services.module').then(
        (m) => m.CustomizedServicesModule,
      ),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(Routing, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
